module.exports = __webpack_public_path__ + "pc/static/img/sold_out.587f3bf7.png";